// extracted by mini-css-extract-plugin
export default {"createEditModalCont":"ViewUsers_createEditModalCont__p1-aR","detailsLists":"ViewUsers_detailsLists__Xmq4a","listContainers":"ViewUsers_listContainers__2peU1"};